import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import './StaffPage.css';
import '../components/Letter.css';

const isBeskikket = (user) =>
  user?.beskikket_pd1 ||
  user?.beskikket_pd2 ||
  user?.beskikket_pd3 ||
  user?.beskikket_sp ||
  user?.beskikket_indfoedsret ||
  user?.beskikket_indfodsret ||
  user?.beskikket_medborgerskab;

const formatBeskikkelseLabel = (user) => {
  const hasVp = user.beskikket_indfoedsret || user.beskikket_indfodsret || user.beskikket_medborgerskab;
  const allPd = user.beskikket_pd1 && user.beskikket_pd2 && user.beskikket_pd3 && user.beskikket_sp;

  if (allPd && !hasVp) {
    return 'Alle Danskprøver (PD1, PD2, PD3, Studieprøven)';
  }

  const labels = [];
  if (user.beskikket_pd1) labels.push('PD1');
  if (user.beskikket_pd2) labels.push('PD2');
  if (user.beskikket_pd3) labels.push('PD3');
  if (user.beskikket_sp) labels.push('Studieprøven');
  if (hasVp) labels.push('VP');

  return labels.join(', ');
};

const MyAppointmentPage = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get('/api/users/me');
        setUserData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (loading) return <div style={{padding:'20px'}}>Henter data...</div>;

  if (!isBeskikket(userData)) {
    return (
      <div className="table-card" style={{textAlign: 'center', padding: '3rem'}}>
        <h2 style={{color: '#666'}}>Ingen Beskikkelse</h2>
        <p>Du er registreret som underviser, men har ikke en aktiv censor-beskikkelse i øjeblikket.</p>
      </div>
    );
  }

  const beskikkelseLabel = formatBeskikkelseLabel(userData);

  return (
    <div>
      <div className="no-print" style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '20px'}}>
        <button 
          onClick={handlePrint} 
          className="action-btn"
          style={{display: 'flex', alignItems: 'center', gap: '8px'}}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
          Print / Gem som PDF
        </button>
      </div>

      <div className="letter-container">
        <div className="letter-header">
          <div>
            <h2 style={{margin: 0, color: '#003366'}}>SIRI</h2>
            <p style={{margin: 0, fontSize: '0.8rem', color: '#666'}}>Styrelsen for International<br/>Rekruttering og Integration</p>
          </div>
          <div style={{textAlign: 'right', fontSize: '0.9rem'}}>
            <p>{new Date().toLocaleDateString('da-DK', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>

        <div className="letter-recipient">
          <p>
            {userData.fornavn} {userData.efternavn}<br/>
            {userData.adresse}<br/>
            {userData.postnummer} {userData.forstad}
          </p>
        </div>

        <div className="letter-body">
          <h1 style={{fontSize: '1.4rem', marginBottom: '2rem'}}>Beskikkelse som censor</h1>

          <p>Kære {userData.fornavn} {userData.efternavn},</p>

          <p>
            Styrelsen for International Rekruttering og Integration (SIRI) har hermed fornøjelsen af at meddele, 
            at du er beskikket som censor inden for følgende område:
          </p>

          <div style={{
            background: '#f8f9fa', 
            padding: '15px', 
            borderLeft: '4px solid #003366', 
            margin: '20px 0',
            fontWeight: 'bold',
            fontSize: '1.1rem'
          }}>
            {beskikkelseLabel}
          </div>

          <p>
            Beskikkelsen gælder indtil videre og forpligter dig til at virke som censor ved de prøver, 
            du bliver tildelt via fordelingssystemet.
          </p>

          <p>
            Du er registreret med følgende kontaktoplysninger i vores system:<br/>
            <strong>Email:</strong> {userData.email}<br/>
            <strong>Telefon:</strong> {userData.telefon}
          </p>

          <p>
            Venlig hilsen,<br/><br/>
            <strong>SIRI</strong><br/>
            Danskprøve administrationen
          </p>
        </div>

        <div className="letter-footer">
          <p>Dette er et automatisk genereret dokument fra SC-Admin.</p>
        </div>

      </div>
    </div>
  );
};

export default MyAppointmentPage;
